<script>
    import Button from "../ui_elements/Button.svelte";
    import ContentBox from "../layouts/ContentBox.svelte";
    import { push } from "svelte-spa-router";
    import PageBox from "../layouts/PageBox.svelte";
    import { onMount } from "svelte";
    import { getQuestionnaireProgress, isLoggedIn } from "../utility.js";

    let pageTitle = '<img src="/assets/logo.png" alt="logo" class="max-h-14 pt-1" >'
    let progress = 0;
    let loggedIn = false;
    let loading = true;

    onMount(async () => {
        try {
            loggedIn = await isLoggedIn();
            if (loggedIn) {
                const data = await getQuestionnaireProgress();
                progress = data.highest_available_category || 0;
            }
        } catch (error) {
                console.log("Error occurred while fetching data");
        } finally {
            loading = false;
        }
  });
</script>

<PageBox {pageTitle}>        
    <ContentBox>
        {#if loading}
            <p>Informationen werden geladen...</p>
        {:else}
            <div class="flex flex-col gap-4 text-justify">
                <div class="gap-4">
                    <b class="text-xl">Willkommen bei deinem Berufsberatungsprogramm!</b> 

                    <div class="gap-4">
                        <p class="font-semibold text-center">Jeder ist einzigartig.</p>
                        <p class="font-semibold text-center">Jeder ist wichtig.</p>
                        <p class="font-semibold text-center">Jeder verdient einen Platz.</p>
                        <p>Mithilfe unseres Fragebogens kannst du deine Interessen und Stärken entdecken, persönliche Berufsempfehlungen für Studiengänge und Ausbildungen erhalten und deinem Platz einen Schritt näher kommen.</p>
                    </div>
                </div>

                <b class="text-xl">Warum Berufsberatung?</b>

                <p>86% der Deutschen Arbeitnehmer hat eine geringe oder keine emotionale Bindung zu seinem Arbeitsplatz (Gallup Engagement Index, 2023). Angesichts der Tatsache, dass wir einen erheblichen Teil unseres Lebens auf Arbeit verbringen, ist das eine alarmierend hohe Zahl. Dies führt zu wirtschaftlichen Verlusten, weniger Produktivität und kann auch persönlich zu einem Gefühl von Sinnlosigkeit, Antriebslosigkeit und einer höheren Krankheitsanfälligkeit führen.</p>

                <div>
                    <b>Seinen Platz im Leben zu finden...</b>
                    <p>...das kann hingegen bedeuten:</p>
                    
                    <div class="flex flex-col lg:flex-row gap-x-40">
                        <ul>
                            <li>Identität</li>
                            <li>Ankommen</li>
                            <li>Gesundheit</li>
                        </ul>
                        <ul>
                            <li>Sinnfindung</li>
                            <li>Ausgeglichenheit</li>
                            <li>Lebensfreude</li>
                        </ul>
                        <ul>
                            <li>Glück</li>
                            <li>Erreichen eines "Flows"</li>

                        </ul>
                    </div>
                    <br>
                    <p>Unser Berufsberatungsprogramm hilft dir dabei, deine Stärken und Fähigkeiten zu erkunden und herauszufinden, welche Ausbildung oder welches Studium perfekt zu dir passt.</p>

                </div>

                <b class="text-xl">So funktioniert's:</b>
                <ol>
                    <li><b>Interaktive Fragen:</b> Beantworte spannende und leicht verständliche Fragen, die dir helfen, deine Interessen und Talente zu entdecken.</li>
                    <li><b>Persönliches Profil:</b> Erhalte ein detailliertes Profil deiner Stärken und Fähigkeiten.</li>
                    <li><b>Maßgeschneiderte Empfehlungen:</b> Basierend auf deinen Interessen und Stärken schlagen wir dir passende Ausbildungs- und Studienmöglichkeiten vor.</li>
                </ol>


                <b class="text-xl">Warum unser Programm?</b>
                <ul>
                    <li><b>Einfach und unterhaltsam:</b> Unsere Fragen sind leicht verständlich, schnell beantwortet und machen Spaß.</li>
                    <li><b>Individuell:</b> Jeder ist einzigartig, und unsere Empfehlungen sind auf dich zugeschnitten und steigern deine Motivation und dein Selbstvertrauen.</li>
                    <li><b>Zukunftsorientiert:</b> Finde heraus, welche Berufe und Studiengänge wirklich zu dir passen und wie du deine Ziele erreichen kannst.</li>
                    
                    <br>

                    <p>Angesichts der Vielzahl an Berufen in der heutigen Landschaft ist es schwierig, sich einen Überblick zu verschaffen oder überhaupt zu wissen, wo man anfangen soll. Zudem kennt man auch sich selbst nur von den Erfahrungen, die man bisher gemacht hat und hat vielleicht Seiten oder Potenziale noch nicht entdeckt.</p>
                    
                    <p>Um dich auf diesem Weg zu unterstützen, haben wir diesen nicht-kommerziellen Fragebogen entwickelt. Hier begegnest du verschiedenen Interessensgebieten - auch solchen, an die du vielleicht noch nie gedacht hast!</p>
                    
                    <p>Aus deinen Interessen, Stärken und deinem gewünschten Arbeitsumfeld werden personalisierte Berufsempfehlungen erstellt. Am Ende des Fragebogens kannst du dein Stärkenprofil betrachten und erhältst detaillierte Beschreibungen sowie Entscheidungshilfen, die dir bei der Wahl zwischen verschiedenen Berufen helfen.</p>

                    <br>

                    <p>Bist du bereit, deine berufliche Zukunft zu entdecken? Mache jetzt den ersten Schritt zu deinem erfüllten Arbeitsleben und finde den Beruf, der zu DIR passt!</p>

                </ul>

                <b class="text-xl">Starte jetzt und finde deinen Weg in eine spannende berufliche Zukunft!</b>

                {#if loggedIn}
                    <b class="text-xl">Was dich erwartet</b>
                    <p>
                        Der folgende Fragebogen soll dir bei der beruflichen Orientierung helfen. Die Bearbeitung dauert ca. 120 Minuten. Die individuellen Fragen sind leicht verständlich und schnell bearbeitet.
                        In dem Fragebogen gibt es 7 Abschnitte, die dir bei der Beantwortung der folgenden Fragen helfen:
                    </p>

                    <ol class="list-decimal">
                        <li><b>Interessen</b>: Was interessiert dich beruflich besonders?</li> 
                        <li><b>Fähigkeiten</b>: Was sind deine größten Stärken?</li> 
                        <li><b>Arbeitsverhalten</b>: Was ist deine bevorzugte Arbeitsweise?</li> 
                        <li><b>Zielgruppen</b>: Mit welchen Zielgruppen würdest du gerne arbeiten?</li> 
                        <li><b>Gegenständen</b>: Mit welchen Dingen würdest du gerne arbeiten?</li> 
                        <li><b>Schulfächer</b>: Mit welchen Schulfächern hättest du gerne weiterhin zu tun?</li> 
                        <li><b>Schulnoten</b>: Wie sind deine Schulnoten? (für manche Ausbildungsberufe oder Studienfächer ist es wichtig, gewisse Vorkenntnisse mitzubringen)</li> 
                        <li><b>Orte</b>: An welchen Orten würdest du gerne arbeiten?</li> 
                    </ol>
                    
                    <p>
                        Anhand deiner Antworten werden dir im Anschluss Studiengänge und Ausbildungsberufe vorgeschlagen, die gut zu dir passen.
                        Viel Spaß und Erfolg!
                    </p>

                    <p>
                        Der Fragebogen ist nicht kommerziell. Alle erhobenen Daten dienen ausschließlich der Auswertung des Tests und werden selbstverständlich vertraulich behandelt.   
                    </p>

                    {#if progress == 0}
                        <Button on:click={() => push('/user-info?redirectTo=questionnaire')} className="ml-auto" variant="submit">Fragebogen starten</Button>
                    {:else}
                        <Button on:click={() => push('/questionnaire')} className="ml-auto" variant="submit">Fragebogen starten</Button>
                    {/if}
                {:else}
                    <Button on:click={() => push('/authentication')} className="ml-auto" variant="submit">Los geht's!</Button>
                {/if}
            </div>
        {/if}
    </ContentBox>
</PageBox>
